import { useEffect, useState } from "react";
import RadnaMestaTabela from "./RadnaMestaTabela";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import Filter from "./Filter";
import axios from "axios";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

const filterDataInitial = {
  rizik: "",
  sprema: "",
  iskustvo: ""
};

function Pocetna() {
  const [radnaMesta, setRadnaMesta] = useState([]);
  const [filterData, setFilterData] = useState(filterDataInitial);
  const [isFilter, setIsFilter] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);

  const { dictionary, setSelectedNavbarDocument, setSelectedProcenaRizika, selectedMainEntity, baseUrl } =
    useGlobalContext();

  const fetchRadnaMesta = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/workplaces/read.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) {
        const mapped = data.data.map((rm) => ({
          ...rm,
          id: String(rm.workplace_id),
          naziv: rm.workplace_name,
          rizik: rm.stepen_rizika || "NEDEFINISANO",
          rizici: rm.rizici || "",
          sprema: rm.sprema || "0",
          iskustvo: rm.iskustvo || "-",
          posebniUslovi: rm.posebni_uslovi || [],
          suma: rm.suma || 0,
          imena: rm.imena || [],
        }));
        setRadnaMesta(mapped);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchRadnaMesta();
    window.addEventListener("machineAdded", fetchRadnaMesta);
    return () => window.removeEventListener("machineAdded", fetchRadnaMesta);
  }, [selectedMainEntity]);

  const filteredRadnaMesta = radnaMesta
    .filter(
      (radnoMesto) =>
        (!filterData.rizik ||
          filterData.rizik === "SVE" ||
          radnoMesto.rizik === filterData.rizik) &&
        (!filterData.sprema || radnoMesto.sprema === filterData.sprema) &&
        (!filterData.iskustvo || radnoMesto.iskustvo === filterData.iskustvo)
    )
    .sort((a, b) => (isCheckedSort ? a.suma - b.suma : b.suma - a.suma));

  const handleClickNazad = () => {
    setSelectedNavbarDocument("");
    setSelectedProcenaRizika(0);
  };

  const handleFilterToggle = () => {
    setIsFilter((prev) => !prev);
    if (isFilter) {
      setFilterData(filterDataInitial);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#ccc",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <div
        style={{
          padding: "7px",
          backgroundColor: "rgb(255, 255, 255)",
          border: "1.5px solid #9f9f9f",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div
          style={{
            overflowY: "auto",
            backgroundColor: "white",
            padding: "7px",
            flex: 1,
            minHeight: 0
          }}
        >
          <RadnaMestaTabela
            radnaMesta={filteredRadnaMesta}
            setRadnaMesta={setRadnaMesta}
            isCheckedSort={isCheckedSort}
            setIsCheckedSort={setIsCheckedSort}
            onRefresh={fetchRadnaMesta}
          />
        </div>
        {isFilter && (
          <Filter filterData={filterData} setFilterData={setFilterData} />
        )}
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "space-between",
          marginTop: "15px"
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "30px", width: "25%" }}>
          {radnaMesta.length}
        </div>
        <div style={{ display: "flex", gap: "10px", width: "40%" }}>
          <div onClick={handleClickNazad} style={{ width: "50%" }}>
            <Button activation={true} style={styles.button}>
              {dictionary["nazad"]}
            </Button>
          </div>
          <div onClick={handleFilterToggle} style={{ width: "50%" }}>
            <Button active={isFilter} style={styles.button}>
              {dictionary["filtriraj"]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pocetna;